import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router-dom';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';
import Header from './Header';
import CalendarOfBookings from './CalendarOfBookings';
import ListOfBookings from './ListOfBookings';
import DetailsOfBookings from './DetailsOfBookings';
import { m } from '../../utils';
import ScrollLock from 'react-scrolllock';

class MyBookings extends Component {
  constructor(props) {
    super(props);
    const bookId = this.props.location.state
      ? this.props.location.state.bookId
      : null;
    const bookingId = this.props.match.params.bookingId;
    const targetStartTime = bookId
      ? this.props.location.state.startTime
      : null;
    const monthStart = (targetStartTime ? m(targetStartTime) : m())
      .clone()
      .startOf('month');
    const monthEnd = monthStart.clone().endOf('month');
    const startDate = monthStart.clone().startOf('isoWeek');
    const endDate = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.state = {
      display: 'index',
      format: 'calendar',
      currentMonth: targetStartTime ? m(targetStartTime) : m(),
      monthStart,
      monthEnd,
      calendarStart: startDate,
      calendarEnd: endDate,
      selectedBooking: null,
      shiftIndex: 0,
      selectedId: bookId,
      bookingLink: bookingId,
      showCancel: false,
      cancelMessage: null
    };
  }

  handleFormatSelect = format => {
    this.setState({ format });
  };

  handleShiftIndexChange = shiftIndex => {
    this.setState({ shiftIndex });
  };

  formatShift = shiftHour =>
    `${shiftHour % 12}${shiftHour / 12 < 1 ? 'am' : 'pm'}`;

  selectBooking = (selectedBooking, shiftIndex = 0) => {
    this.setState({ selectedBooking, shiftIndex, display: 'details' });
  };

  backAction = e => {
    e.preventDefault();
    const { display } = this.state;
    const { status } = this.props;
    switch (display) {
      case 'index':
        window.location.assign('/dashboard');
        break;
      case 'details':
        if (status === 'weekly_lease') {
          window.location.assign('/dashboard');
        } else {
          this.props.history.push('/mybookings');
          this.setState({
            display: 'index',
            selectedId: null,
            bookingLink: null
          });
        }
        break;
      default:
        break;
    }
  };

  // showCancelModal = reason => {
  //   this.setState({ showCancel: true, cancelMessage: reason });
  // }

  // cancelModal = () => {
  //   return (
  //     <Modal open={this.state.showCancel}>
  //       <div className="cancel-modal">
  //         <p>
  //           {this.state.cancelMessage}
  //         </p>
  //         <Button
  //           color="#414141"
  //           className="cancel-butt"
  //           margin="1em 0 0 0"
  //           onClick={() => {
  //             this.setState({ showCancel: false, cancelMessage: null })
  //             window.location.reload();
  //           }}
  //           label="Close"
  //         />
  //       </div>
  //     </Modal>
  //   )
  // }

  nextMonth = () => {
    const nextMonth = this.state.currentMonth.add(1, 'month');
    const monthStart = nextMonth.clone().startOf('month');
    const start = monthStart.clone().startOf('isoWeek');
    const monthEnd = nextMonth.clone().endOf('month');
    const finish = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.setState({
      currentMonth: nextMonth,
      startDate: start,
      calendarStart: start,
      calendarEnd: finish,
      monthStart,
      monthEnd
    });
  };

  prevMonth = () => {
    const prevMonth = this.state.currentMonth.subtract(1, 'month');
    const monthStart = prevMonth.clone().startOf('month');
    const start = monthStart.clone().startOf('isoWeek');
    const monthEnd = prevMonth.clone().endOf('month');
    const finish = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.setState({
      currentMonth: prevMonth,
      startDate: start,
      calendarStart: start,
      calendarEnd: finish,
      monthStart,
      monthEnd
    });
  };

  render() {
    const {
      display,
      format,
      selectedBooking,
      shiftIndex,
      currentMonth,
      calendarStart,
      calendarEnd,
      monthStart,
      monthEnd,
      selectedId,
      bookingLink
    } = this.state;

    const { status, loggedIn } = this.props;
    return window.innerWidth < 768 ? (
      <Redirect to="/downloadapp" />
    ) : (
      <div className="container my-bookings__container">
        <div className="my-bookings">
          <Header header="Bookings" backAction={this.backAction} />
          <div className="desktop-subheader">My Bookings</div>
          <div className="sidebar-container">
            <SideBarContent status={status} signedIn={loggedIn} />
          </div>
          <ScrollLock>
            <MediaQuery maxWidth={767}>
              <div className="index-container">
                {display === 'details' ? null : (
                  <div className="format-select">
                    <Button
                      className="calendar-select"
                      label="Calendar"
                      color="#414141"
                      primary={format === 'calendar'}
                      padding="0"
                      onClick={() => this.handleFormatSelect('calendar')}
                    />
                    <Button
                      className="list-select"
                      label="List"
                      color="#414141"
                      primary={format === 'list'}
                      padding="0"
                      onClick={() => this.handleFormatSelect('list')}
                    />
                  </div>
                )}
                {display === 'index' && format === 'calendar' ? (
                  <CalendarOfBookings
                    currentMonth={currentMonth}
                    calendarStart={calendarStart}
                    calendarEnd={calendarEnd}
                    nextMonth={this.nextMonth}
                    prevMonth={this.prevMonth}
                    formatShift={this.formatShift}
                    selectBooking={this.selectBooking}
                    selectedBooking={selectedBooking}
                    selectedId={selectedId}
                    bookingLink={bookingLink}
                    shiftIndex={shiftIndex}
                    handleShiftIndexChange={this.handleShiftIndexChange}
                  />
                ) : null}
                {display === 'index' && format === 'list' ? (
                  <ListOfBookings
                    currentMonth={currentMonth}
                    monthStart={monthStart}
                    monthEnd={monthEnd}
                    nextMonth={this.nextMonth}
                    prevMonth={this.prevMonth}
                    formatShift={this.formatShift}
                    selectBooking={this.selectBooking}
                    selectedBooking={selectedBooking}
                  />
                ) : null}
              </div>
            </MediaQuery>
            <MediaQuery minWidth={768}>
              <div className="index-container">
                <div className="format-select">
                  <Button
                    className="calendar-select"
                    label="Calendar"
                    color="#414141"
                    primary={format === 'calendar'}
                    onClick={() => this.handleFormatSelect('calendar')}
                  />
                  <Button
                    className="list-select"
                    label="List"
                    color="#414141"
                    primary={format === 'list'}
                    onClick={() => this.handleFormatSelect('list')}
                  />
                </div>
                {format === 'calendar' ? (
                  <CalendarOfBookings
                    currentMonth={currentMonth}
                    calendarStart={calendarStart}
                    calendarEnd={calendarEnd}
                    nextMonth={this.nextMonth}
                    prevMonth={this.prevMonth}
                    formatShift={this.formatShift}
                    selectBooking={this.selectBooking}
                    selectedBooking={selectedBooking}
                    selectedId={selectedId}
                    bookingLink={bookingLink}
                    shiftIndex={shiftIndex}
                    handleShiftIndexChange={this.handleShiftIndexChange}
                  />
                ) : null}
                {format === 'list' ? (
                  <ListOfBookings
                    currentMonth={currentMonth}
                    monthStart={monthStart}
                    monthEnd={monthEnd}
                    nextMonth={this.nextMonth}
                    prevMonth={this.prevMonth}
                    formatShift={this.formatShift}
                    selectBooking={this.selectBooking}
                    selectedBooking={selectedBooking}
                  />
                ) : null}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
              {display === 'details' ? (
                <DetailsOfBookings
                  formatShift={this.formatShift}
                  selectedBooking={selectedBooking}
                  selectedId={selectedId}
                  removeFromSchedule={this.removeFromSchedule}
                />
              ) : null}
            </MediaQuery>
            <MediaQuery minWidth={768}>
              <DetailsOfBookings
                formatShift={this.formatShift}
                selectedBooking={selectedBooking}
                selectedId={selectedId}
                removeFromSchedule={this.removeFromSchedule}
              />
            </MediaQuery>
          </ScrollLock>
        </div>
      </div>
    );
  }
}

export default MyBookings;



// WEBPACK FOOTER //
// ./src/components/MyBookings/index.js